import { GitPanel, type GitTabProps } from "./GitPanel";

export function GitTab(props: GitTabProps) {
  return (
    <GitPanel
      key={JSON.stringify([
        props.conversationId,
        props.selection.workspaceId,
        props.selection.repositoryId,
      ])}
      {...props}
    />
  );
}
